import React from "react"
import { graphql, useStaticQuery  } from "gatsby"
import Layout from "../components/Layout"
import Hero from "../components/Hero"
import Services from "../components/Services"
import Jobs from "../components/Jobs"
import Projects from "../components/Projects"
import Blogs from "../components/Blogs"
export default () => {
  // const {allStrapiProjects:{nodes:projects}} = {}
  // const {allStrapiProjects:{nodes:projects}} = data
  const query = graphql`
  {
    file(relativePath: {eq: "projects-3.jpg"}) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
const {
  file: {
    childImageSharp: { fluid },
  },
} = useStaticQuery(query)

  const projects = [
    {
      "id": 1,
      "title": "WordVoyage",
      "description": "An Adventure in Language that helps you move away from rote memorization and focuses on giving you an attack strategy that could be applied to any word through Latin and Greek roots. A conversational approach allows you to put the grammar into a practical context, and really understand how it works, on a practical and intuitive level. The goal is to communicate fluently in English, to be able to expand upon ideas, comfortably, clearly and with confidence, and especially, to have fun!",
      "github": "https://github.com/orgs/YogayaInc/projects/3",
      "url": "http://wordvoyage.com/",
      "featured": true,
      "created_at": "2022-04-13T17:36:16.309Z",
      "updated_at": "2022-04-13T17:36:16.309Z",
      "stack": [
        {
          "id": 1,
          "title": "php"
        },
        {
          "id": 2,
          "title": "react"
        }
        ,
        {
          "id": 2,
          "title": "node js"
        }
      ],
      "image": fluid
    },
    {
      "id": 2,
      "title": "Spectral Workbench",
      "description": "SpectralWorkbench.org is a web based application to collect, archive, share, and analyze spectral data, for Public Lab DIY spectrometers and other spectrometers. With it, you can: connect your USB Desktop Spectrometry Kit, scan and save samples, wavelength calibrate your spectrometer, plot light intensity as a function of wavelength (average digital consumer cameras have a range of 400 to 700 nm), create sets of multiple spectra to visually compare and analyze scans, download CSV data for offline analysis, view others' data and discuss",
      "github": "https://github.com/publiclab/spectral-workbench",
      "url": "https://spectralworkbench.org/",
      "featured": true,
      "created_at": "2022-04-13T17:36:16.309Z",
      "updated_at": "2022-04-13T17:36:16.309Z",
      "stack": [
        {
          "id": 1,
          "title": "Ruby on Rails"
        },
        {
          "id": 2,
          "title": "Javascript"
        }
      ],
      "image": fluid
    },
    
  ]
  return (
    <Layout>
      <Hero />
      <Services />
      <Jobs />
      <Projects projects={projects} title="featured projects" showLink/>
    </Layout>
  )
}
// export const query = graphql`
//   {
//     allStrapiProjects(filter: {featured: {eq: true}}) {
//       nodes {
//         github
//         id
//         description
//         title
//         url
//         image {
//           childImageSharp {
//             fluid {
//               ...GatsbyImageSharpFluid
//             }
//           }
//         }
//         stack {
//           id
//           title
//         }
//       }
//     }
//   }
// `

 